export default __webpack_public_path__ + "static/media/final-goal.fc4cf011.svg";